<template>
    <div>
        <!-- MAIN IMAGE -->
        <section>
            <v-layout column align-center justify-center class="white--text">
                <img src="../assets/img/oblo/paesaggio 4.jpeg" alt="" style="object-fit: cover" height="600px" width="100%">
            </v-layout>
        </section>

        <!-- INTRO -->
        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5">
                    <p style="font-size: xx-large; font-weight: 500">Oblo' B&B</p>
                    <p class="sub-intro">
                        {{$t("oblobb.intro")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- IMAGES -->
        <section>
            <v-layout row wrap>
                <v-flex xs12 sm12 md6 lg6 class="pr-1">
                    <!-- <img src="../assets/nostromo/IMG_20190707_173120.jpg" class="my-fit"> -->
                    <img src="../assets/img/mozzo/mozzo 2.jpeg" class="my-fit">
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 class="pl-1">
                    <img src="../assets/img/nostromo/nostromo 3.jpeg" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- SUB INTRO -->
        <section>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5">
                    <p class="sub-intro">
                        {{$t("oblobb.sub")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- SUB CONTINUE -->
        <section>
            <v-layout row wrap style="min-height:200px; background-color: #2196f3;">
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="py-5 white--text">
                    <p class="sub-intro">
                        {{$t("oblobb.sub_continue")}}
                    </p>
                    <p class="sub-intro">
                        {{$t("oblobb.sub_continue2")}}
                    </p>
                    <!-- <p class="sub-intro">
                        {{$t("oblobb.sub_continue3")}}
                    </p> -->
                </v-flex>
            </v-layout>
        </section>

        <!-- IMAGES -->
        <section>
            <v-layout row wrap>
                <v-flex xs12 sm12 md4 lg4 class="px-1">
                    <img src="../assets/img/ammiraglio/ammiraglio 3.jpeg" class="my-fit">
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 class="px-1">
                    <img src="../assets/img/ammiraglio/ammiraglio 6.jpeg" class="my-fit">
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 class="px-1">
                    <img src="../assets/img/capitano/capitano 2.jpeg" class="my-fit">
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }

    .my-fit-big{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 650px;
    }
</style>